const Routes = {
    publicRoutes: {
        HomePage: "/",
        KidneyFailure: "/kidney-failure",
        ClinicDetails: "/center",
        HealingStories: "/healing-stories",
        PainManagement: "/pain-management",
        Diseases: "/all-diseases",
        DiseaseDetail: "/blog",
        DoctorDetail: "/doctor",
        TermsCondition: "/terms-condition",
        PrivacyPolicy: "/privacy-policy",
        ShippingPolicy: "/shipping-policy",
        ReturnPolicy: "/return-policy",
        ConsultDetail: '/consult-experts',
        Consult: "/consult",
        Login: "/login",
        NotFound: "/404",
        OurCenters: "/our-centers",
        OurExperts: "/our-experts",
        EditorialPolicy: "/editorial-policy",
        ContentIntegrity: "/content-integrity",
        AboutUs: "/about-us",
        Blogs: {
            Herbs: {
                HerbsFood: "/herbs-food-blog",
                HerbsFoodDetail: "/herbs-food-blog-detail",
            },
            Medicine: {
                MedicineBlog: "/our-blog",
                MedicineBlogDetail: "/medicine-blog-detail",
            },
            Video: {
                VideoBlog: "/video-blog",
                VideoBlogDetail: "/video-blog-detail",
            },
        },

    },
    adminRoutes: {
        Dashboard: "/admin",
        Enquiry: {
            ClinicEnquiry: "/admin/enquiry/clinic-enquiry",
            DoctorEnquiry: "/admin/enquiry/doctor-enquiry",
        },
        Clinic: {
            ClinicAdd: "/admin/clinic/add",
            ClinicList: "/admin/clinic/list"
        },
        DiseaseBlog: {
            DiseaseAdd: "/admin/disease-blog/add",
            DiseaseUpdate: "/admin/disease-blog/edit",
            DiseaseList: "/admin/disease-blog/list",
        },
        Doctors: {
            DoctorsAdd: "/admin/doctors/add",
            DoctorsList: "/admin/doctors/list",
        },
        HealingStories: {
            HealingStoriesAdd: "/admin/healing-stories/add",
            HealingStoriesList: "/admin/healing-stories/list",
        },
        HerbsFood: {
            HerbsFoodAdd: "/admin/herbs-food/add",
            HerbsFoodList: "/admin/herbs-food/list",
        },
        BlogVideos:{
            BlogVideosAdd: "/admin/blog-videos/add",
            BlogVideosList: "/admin/blog-videos/list",
        },
        MedicineBlog:{
            MedicineBlogAdd: "/admin/medicine-blog/add",
            MedicineBlogList: "/admin/medicine-blog/list",
        }
    }
};
export default Routes;
